module.exports = __webpack_public_path__ + "media/bootstrap-icons/bounding-box-circles-6419cd7e.svg";